/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSReviewPage() {
  customValidationInit(false);
  aspControlValidationInit();
}
